import React, { useState } from "react";
import { Collapse } from "react-collapse";
import classnames from "classnames";

interface CollapsibleContainerProps {
  content: string;
  id: string;
  normalButton?: boolean;
}

export const CollapsibleContainer: React.FC<CollapsibleContainerProps> = ({
  content,
  id,
  normalButton,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <Collapse
        theme={{ collapse: "react-collapse--collapse" }}
        isOpened={isOpen}
      >
        <div
          id={id}
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      </Collapse>
      <button
        className={classnames(
          "accordion-toggler__label",
          { "accordion-toggler__normal-label": normalButton },
          { "mt-2": !normalButton }
        )}
        aria-expanded={isOpen}
        aria-controls={id}
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        {isOpen ? "Vis mindre" : "Vis mer"}
      </button>
    </>
  );
};
